import type {} from '@mui/lab/themeAugmentation';
import { CssBaseline, ThemeProvider as MUIThemeProvider, PaletteMode } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { PropsWithChildren, useMemo } from 'react';
import { ThemeOptions } from '../../theme/options';
import { createTheme } from './createTheme';

export function BrightyThemeProvider({
  mode,
  options,
  children,
}: PropsWithChildren<{
  mode: PaletteMode;
  options: ThemeOptions;
}>) {
  const theme = useMemo(() => createTheme(mode, options), [mode, options]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </LocalizationProvider>
  );
}
